
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"100","viewBox":"0 0 110 110"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.606 75.908c1.9-6.306 5.832-11.683 9.726-17.04 1.028-1.4 2.056-2.807 3.044-4.23a34.8 34.8 0 10-57.169-.02 205.061 205.061 0 003.044 4.23c3.914 5.357 7.848 10.754 9.726 17.04h31.629zm-15.814 25.3A15.81 15.81 0 0050.606 85.4v-3.166H18.977V85.4a15.81 15.81 0 0015.814 15.811zM18.977 34.791a3.163 3.163 0 01-6.326 0 22.129 22.129 0 0122.14-22.14 3.163 3.163 0 010 6.326 15.81 15.81 0 00-15.814 15.814z","fill":"#63cdf5"}})])
          )
        }
      }
    